import { useEffect, useState } from "react";
import { useApp } from "../../context/AppContext";
import { publicTestimonials, testimonialPhotoUrl } from "../../lib/api";

const H = { en: "What schools and families say", ar: "ماذا تقول المدارس والأسر" };

// Real, permission-cleared quotes managed in Back office → Testimonials. Hidden completely while none are published.
export function TestimonialsSection() {
  const { lang } = useApp();
  const [items, setItems] = useState([]);
  useEffect(() => { publicTestimonials().then((d) => setItems(Array.isArray(d) ? d : [])).catch(() => setItems([])); }, []);
  const list = items.filter((x) => (lang === "ar" ? x.quote_ar || x.quote_en : x.quote_en || x.quote_ar));
  if (!list.length) return null;
  return (
    <section className="relative px-4 sm:px-6 pt-4 pb-6" data-testid="lp-testimonials">
      <div className="relative max-w-7xl mx-auto">
        <h2 className="lp-h text-base md:text-lg font-semibold text-[#5B6478]">{H[lang] || H.en}</h2>
        <div className="mt-4 grid md:grid-cols-3 gap-4">
          {list.map((x, i) => (
            <figure key={x.id} data-testid={`lp-testimonial-${i}`} className="rounded-2xl bg-white border border-[#D6E0FF] p-5 shadow-[0_12px_30px_-20px_rgba(0,31,128,0.35)] transition-transform duration-300 hover:-translate-y-1">
              <blockquote className="text-sm sm:text-[15px] leading-relaxed text-[#0B1437]" dir="auto">“{lang === "ar" ? x.quote_ar || x.quote_en : x.quote_en || x.quote_ar}”</blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                {x.has_photo ? <img src={testimonialPhotoUrl(x.id)} alt="" loading="lazy" className="w-10 h-10 rounded-full object-cover bg-[#F3F6FF]" /> : <span className="w-10 h-10 rounded-full grid place-items-center bg-[#0038EB] text-white text-sm font-semibold">{x.name[0]}</span>}
                <span><span className="block text-sm font-semibold text-[#0B1437]" dir="auto">{x.name}</span><span className="block text-xs text-[#5B6478]" dir="auto">{[x.role, x.school].filter(Boolean).join(" · ")}</span></span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
